<template>
  <div class="mobile-sidenav">
    <div class="d-flex flex-column justify-content-center mt-1">
      <div>
        <router-link
          class="menu-item-link"
          to="/"
          @click.native="$emit('clickLink')"
          exact
        >
          <div class="menu-item">
            <div class="md-icon md-icon-blog" />
            <span class="menu-item-name pl-4">
              Blog
            </span>
          </div>
        </router-link>
        <router-link
          class="menu-item-link"
          to="/categories"
          @click.native="$emit('clickLink')"
          exact
        >
          <div class="menu-item">
            <div class="md-icon md-icon-categories" />
            <span class="menu-item-name pl-4">
              Categories
            </span>
          </div>
        </router-link>
        <router-link
          class="menu-item-link"
          to="/tags"
          @click.native="$emit('clickLink')"
          exact
        >
          <div class="menu-item">
            <div class="md-icon md-icon-tags" />
            <span class="menu-item-name pl-4">
              Tags
            </span>
          </div>
        </router-link>
        <router-link
          class="menu-item-link"
          to="/reviews"
          @click.native="$emit('clickLink')"
          exact
        >
          <div class="menu-item">
            <div class="md-icon md-icon-reviews" />
            <span class="menu-item-name pl-4">
              Reviews
            </span>
          </div>
        </router-link>
        <router-link
          class="menu-item-link"
          to="/git"
          @click.native="$emit('clickLink')"
          exact
        >
          <div class="menu-item">
            <div class="md-icon md-icon-git" />
            <span class="menu-item-name pl-4">
              Reviews
            </span>
          </div>
        </router-link>
      </div>
      <div
        class="d-flex justify-content-lg-start align-items-center logout-wrapper logout-icon"
      >
        <div class="d-flex close-menu pointer" @click="$emit('logout')">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 4.24702V17.0207C0 18.1968 0.490041 19.2423 1.27411 20.059C2.05817 20.8431 3.07092 21.2678 4.24702 21.2678H10.6502V18.6215H4.24702C3.36494 18.6215 2.67889 17.9028 2.67889 17.0207V4.24702C2.67889 3.36495 3.36494 2.67889 4.24702 2.67889H10.6502V0H4.24702C3.07092 0 2.05817 0.457371 1.27411 1.24144C0.490041 2.05817 0 3.07092 0 4.24702ZM7.02391 8.102V13.1984C7.02391 13.7865 7.54662 14.2765 8.13467 14.2765H14.0478V18.2948C14.0478 18.6542 14.2438 18.9482 14.5705 19.1116C14.7012 19.1443 14.8319 19.1443 14.8972 19.1443C15.1259 19.1443 15.3219 19.0789 15.4853 18.9156L23.1626 11.2383C23.5219 10.9442 23.4893 10.3562 23.1626 10.0295L15.4853 2.38486C15.0279 1.89482 14.0478 2.18885 14.0478 2.97291V7.02392H8.13467C7.54662 7.02392 7.02391 7.51396 7.02391 8.102Z"
              fill="white"
            />
          </svg>
          <span class="pl-4 close-menu-text">
            Logout
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    expanded: []
  }),
  methods: {
    toggle(item) {
      if (this.expanded.includes(item)) {
        const index = this.expanded.indexOf(item);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(item);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  color: #fff;
}
.router-link-active {
  color: #fff;
}
.close-icon {
  padding: 25px 0 0 20px;
}
.logout-icon {
  padding: 30px;
}
.close-menu-text {
  font-size: 18px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-item-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 4px 4px 4px 25px;
}
.menu-item-link:hover {
  color: #fff;
}
.menu-item {
  min-height: 70px;
  display: flex;
  align-items: center;
}
.menu-item-name {
  font-size: 19px;
  color: #fff;
}
.link-divider {
  width: 100%;
  margin-top: 0;
  margin-bottom: -5px;
  opacity: 0.2;
  border: 1px dashed #ffffff;
  margin-left: -15px;
}
.menu-caret {
  position: absolute;
  right: 10%;
  color: #fff;
}
.submenu-caret {
  position: absolute;
  right: 10%;
}
.submenu-wrapper {
  padding-left: 60px;
  color: #fff;
}
.submenu-item {
  padding: 17px 25px 25px 25px;
}
.submenu-item-tier3 {
  padding: 18px 25px 25px 45px;
}
.logout-wrapper {
  width: 100%;
}
</style>
